import { FC, useEffect } from 'react'
import { userStore } from '../store/user'
import EditableTable from '../components/Table'
import { PageBreadcrumb } from '../components/PageBreadcrumb'
import { Button, Checkbox, message, Select } from 'antd'
import { updateUserRole } from '../api/user'
import { UserRole } from '../helpers/types/user'

const ROLE_OPTIONS: { value: UserRole; label: string }[] = [
	{ value: 'worker', label: 'Работник' },
	{ value: 'admin', label: 'Администратор' },
	{ value: 'supervisor', label: 'Супервайзер' }
]

export const Users: FC = () => {
	const { fetchUsers, users, addUser, createUser } = userStore()

	useEffect(() => {
		fetchUsers()
	}, [fetchUsers])

	const handleRoleChange = async (userId: string, role: UserRole) => {
		try {
			await updateUserRole(userId, role)
			// optimistically update local state
			const updated = users.find((u) => u.id === userId)
			if (updated) {
				createUser({ ...updated, role })
			}
			message.success('Роль обновлена')
		} catch {
			message.error('Не удалось изменить роль')
		}
	}

	if (!users.length) return <></>

	return (
		<div>
			<PageBreadcrumb items={[{ label: 'Пользователи' }]} />
			<header
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center'
				}}>
				<h1>Пользователи</h1>
				<Button type="primary" onClick={addUser}>
					Добавить пользователя
				</Button>
			</header>
			<main>
				<EditableTable
					scroll={{ x: 1300 }}
					columns={[
						{
							title: 'Имя',
							dataIndex: 'firstName',
							key: 'firstName',
							editable: true
						},
						{
							title: 'Фамилия',
							dataIndex: 'lastName',
							key: 'lastName',
							editable: true
						},
						{
							title: 'Отчество',
							dataIndex: 'middleName',
							key: 'middleName',
							editable: true
						},
						{
							title: 'Логин',
							dataIndex: 'username',
							key: 'username'
						},
						{
							title: 'Должность',
							dataIndex: 'position',
							key: 'position',
							editable: true
						},
						{
							title: 'Роль',
							dataIndex: 'role',
							key: 'role',
							render: (role: string, record: { id: string }) => (
								<Select<UserRole>
									value={role as UserRole}
									style={{ width: 140 }}
									options={ROLE_OPTIONS}
									onChange={(newRole) =>
										handleRoleChange(
											record.id,
											newRole
										)
									}
								/>
							)
						},
						{
							title: 'Телефон',
							dataIndex: 'phone',
							key: 'phone',
							editable: true,
							className: 'table-cell-one-letter'
						},
						{
							title: 'Удален',
							dataIndex: 'isDeleted',
							key: 'isDeleted',
							render: (isDeleted: boolean) => (
								<Checkbox
									defaultChecked={isDeleted}
								/>
							)
						},
						{
							title: 'Последний вход',
							dataIndex: 'lastSeen',
							key: 'lastSeen',
							className: 'table-cell-date',
							render: (date: string) =>
								new Date(date).toLocaleString('ru')
						},
						{
							title: 'Создан',
							dataIndex: 'createdAt',
							key: 'createdAt',
							className: 'table-cell-date',
							render: (date: string) =>
								new Date(date).toLocaleString('ru')
						}
					]}
					dataSource={users}
					handleAdd={() => {}}
					handleSave={() => {}}
				/>
			</main>
		</div>
	)
}
